import { createFileRoute } from '@tanstack/react-router';
import GlobalPrivacySettings from '../../../../../packages/tracker-settings-crate/components/GlobalAppSettings/GlobalPrivacySettings';

export const Route = createFileRoute('/_secured/administration/account/app/privacy')({
  component: GlobalPrivacySettings,
});
